import React from "react";
import {useEffect, useState} from "react";

function PVC_PIPE_CONNECTOR() {
    const [data, setData] = useState([]);
    const [isLoading, setisLoading] = useState(true);
    // setLoding(false);
    useEffect(() => {
        fetch("https://dharatiengineering.in/ad_dharati/Api/Product/Images/PVC-PIPE-CONNECTER", setisLoading(true)).then((res) => {
            return res.json();
        }).then((res) => {
            setData(res.data);
            setisLoading(false);
        });
    }, []);

    const PVCPipeConnectorDetails = data.map((PVCPipeConnector) => {
        return (
            <>
                <div className="portfolio-item filter-web col-lg-3 col-sm-6">
                    <div className="portfolio-wrap">
                        <img src={
                                "https://dharatiengineering.in/ad_dharati/Images/product/" + PVCPipeConnector.Path
                            }
                            className="img-fluid shadow-4"
                            alt="Latest Corporation img kichan sink"/>
                    </div>
                </div>
            </>
        );
    });

    return (
        <>
            <section id="portfolio" className="portfolio">
                <div className="container">
                    <div>
                        <hr/>
                        <h2 className="text-center"style={{ color : '#AB7442'}}>PVC PIPE CONNECTOR</h2>
                        <hr/>
                    </div>
                    <div className="row portfolio-container animate__animated animate__fadeInDown">
                        {PVCPipeConnectorDetails}
                        </div>
                </div>
            </section>
        </>
    );
}

export default PVC_PIPE_CONNECTOR;
